import React, { useState } from 'react';
import projectsData from '../data/projectsData';

const Projects = () => {
  const [selectedCaseStudy, setSelectedCaseStudy] = useState(null);

  return (
    <section className="Portfolio" id="Portfolio">
      <h2 className="heading">Latest <span>Projects</span></h2>
      <div className="portfolio-container">
        {projectsData.map((project) => (
          <div className="portfolio-box case-study-card" key={project.title} onClick={() => setSelectedCaseStudy(project)}>
            <img src={project.image} alt={project.alt} width="1200" height="749" loading="lazy" decoding="async" />
            <div className="portfolio-layer">
              <h4>{project.title}</h4>
              <p>{project.summary}</p>
              <a href={project.link} onClick={(event) => event.stopPropagation()}>
                <i className="fa-solid fa-up-right-from-square"></i>
              </a>
            </div>
          </div>
        ))}
      </div>
      {selectedCaseStudy && (
        <div className="case-study-modal" onClick={() => setSelectedCaseStudy(null)}>
          <div className="case-study-content" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="case-study-close" onClick={() => setSelectedCaseStudy(null)} aria-label="Close case study">
              <i className="fa-solid fa-xmark"></i>
            </button>
            <div className="case-study-hero">
              <img src={selectedCaseStudy.image} alt={`${selectedCaseStudy.title} preview`} width="1200" height="749" loading="lazy" decoding="async" />
              <div>
                <span>Project Case Study</span>
                <h3>{selectedCaseStudy.title}</h3>
                <a href={selectedCaseStudy.link} target="_blank" rel="noopener noreferrer" className="btn">View LinkedIn Post</a>
              </div>
            </div>
            <div className="case-study-grid">
              <div className="case-study-panel">
                <h4>Business Problem</h4>
                <p>{selectedCaseStudy.businessProblem}</p>
              </div>
              <div className="case-study-panel">
                <h4>Dataset Used</h4>
                <p>{selectedCaseStudy.datasetUsed}</p>
              </div>
              <div className="case-study-panel">
                <h4>Tools</h4>
                <div className="case-study-tags">
                  {selectedCaseStudy.tools.map((tool) => <span key={tool}>{tool}</span>)}
                </div>
              </div>
              <div className="case-study-panel">
                <h4>KPIs Tracked</h4>
                <div className="case-study-tags">
                  {selectedCaseStudy.kpisTracked.map((kpi) => <span key={kpi}>{kpi}</span>)}
                </div>
              </div>
              <div className="case-study-panel">
                <h4>Insight Generated</h4>
                <p>{selectedCaseStudy.insightGenerated}</p>
              </div>
              <div className="case-study-panel">
                <h4>Decision Impact</h4>
                <p>{selectedCaseStudy.decisionImpact}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;
